<app-config-top-nav></app-config-top-nav>

<div class="shifts-container">
  <!-- Loading -->
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <!-- Header -->
  <div class="header" *ngIf="!isLoading">
    <h2>Shifts</h2>

    <div class="header-actions">
      <button class="btn btn-primary" (click)="openCreateModal()">+ New Shift</button>
    </div>
  </div>

  <!-- Sticky Pagination -->
  <div class="pagination sticky" *ngIf="!isLoading">
    <div class="page-controls">
      <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
    </div>

    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize()">
        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
      </select>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-container" *ngIf="!isLoading">
    <div class="filters-row">
      <label class="filter-field search-field">
        <app-search-bar
          [value]="filters.searchTerm"
          [debounceMs]="1000"
          placeholder="Search shift name"
          (searchChange)="onSearchTermChange($event)">
        </app-search-bar>
      </label>
    </div>
  </div>

  <!-- Shifts List -->
  <div class="shifts-list">
    <div *ngFor="let shift of shifts$ | async" class="shift-row">
      <div class="shift-info">
        <div class="shift-name">{{ shift.name }}</div>
        <div class="shift-grace-period">Grace Period: {{ shift.gracePeriodMinutes }} min</div>
        <div class="shift-meta">
          Departments: {{ shift.departments || 0 }} | Pay Codes: {{ shift.payCodes.length || 0 }}
        </div>
        <div class="shift-meta" *ngIf="shift.payCodes.length">
          {{ getPayCodesLabel(shift) }}
        </div>
      </div>

      <div class="shift-actions">
        <button class="btn edit" (click)="openEditModal(shift)">Edit</button>
        <button class="btn delete" (click)="confirmDelete(shift)">Delete</button>
      </div>
    </div>
  </div>
</div>

<!-- Create/Edit Modal -->
<div *ngIf="modalOpen" class="modal-backdrop">
  <div class="modal shift-modal" (click)="$event.stopPropagation()">
    <h2>{{ isEditMode ? 'Edit Shift' : 'New Shift' }}</h2>

    <form #shiftForm="ngForm" (ngSubmit)="submitShift(shiftForm)">
      <label for="shiftName">Name</label>
      <input id="shiftName" type="text" [(ngModel)]="formModel.name" name="name" required />

      <label for="gracePeriodMinutes">Grace Period Minutes</label>
      <input
        id="gracePeriodMinutes"
        type="number"
        min="0"
        step="1"
        [(ngModel)]="formModel.gracePeriodMinutes"
        name="gracePeriodMinutes"
        required
      />

      <div class="modal-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Delete Modal -->
<div *ngIf="deleteConfirmOpen" class="modal-backdrop">
  <div class="modal confirm-modal" (click)="$event.stopPropagation()">
    <h2>Delete Shift</h2>
    <p class="modal-text">
      Are you sure you want to delete <strong>{{ shiftToDelete?.name }}</strong>?
    </p>

    <div class="modal-buttons confirm-buttons">
      <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="deleteShift()">Delete</button>
    </div>
  </div>
</div>

<!-- Toast -->
<div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
  <img class="icon" alt="icon" />
  <span>{{ toastMessage }}</span>
</div>